import { render, staticRenderFns } from "./CpdProviders.vue?vue&type=template&id=84b4e992&scoped=true"
import script from "./CpdProviders.vue?vue&type=script&lang=js"
export * from "./CpdProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4e992",
  null
  
)

export default component.exports